import { NoddiIcon } from 'noddi-ui-common';

export const ClearButton = ({
  handleClearDate,
  label = 'Clear date'
}: {
  handleClearDate: (e: React.MouseEvent) => void;
  label?: string;
}) => {
  return (
    <button
      type='button'
      onClick={handleClearDate}
      aria-label={label}
      className='absolute right-2 bottom-0 z-10 flex size-9 items-center justify-center rounded-xs text-muted-foreground transition-colors hover:text-foreground focus-visible:ring-2 focus-visible:ring-ring focus-visible:outline-hidden'
    >
      <NoddiIcon name='X' />
    </button>
  );
};
